import { BuildingComplex, ClipboardList, Target, Truck } from 'lucide-react';

/** Le icone dei quattro step del questionario, nell'ordine di STEPS. */
export const STEP_ICONS = [BuildingComplex, Truck, Target, ClipboardList];
